import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import {ToolsComponent} from "./tools.component";

const routes: Routes = [
  {
    path: 'tools',
    component: ToolsComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.TOOLS }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ToolsRoutingModule { }
